(function ($, api) {
    $.get(api,
        function (components) {
            for (var i =0; i < components.length; i++) {
                var c = components[i];
                switch (c.appendMode) {
                    case "append":
                        $(c.target).append(c.content);
                        break;
                    case "after":
                        $(c.content).insertAfter(c.target);
                        break;
                }
            }
        });
})(jQuery, finance_api_url);